import { createMutationHelper } from '@utils/swr'
import { type CampaignAdminAddNotesRequest } from '../types/apiRequest'
import { type FortuneApis } from '../types/apis'

const { useMutation } = createMutationHelper<FortuneApis['post']['adminNote'], never, CampaignAdminAddNotesRequest>({
  client: 'fastpassAdmin',
  key: '/campaigns',
  fetcher: (_url, { arg, client }) => {
    if (!arg.code) {
      return Promise.reject(new Error('Campaign code is required'))
    }
    return client.post(`/campaigns/${arg.code}/admin/payment-transactions/${arg.payment_transaction_id}/notes`, {
      delivery_reason: arg.delivery_reason,
    })
  },
})

export const useApiMutationAdminAddNotes = useMutation
